import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const navWrapperFn = /* @__PURE__ */ createRecipe('nav-wrapper', {}, [])

const navWrapperVariantMap = {}

const navWrapperVariantKeys = Object.keys(navWrapperVariantMap)

export const navWrapper = /* @__PURE__ */ Object.assign(memo(navWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'navWrapper',
  __getCompoundVariantCss__: navWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: navWrapperVariantKeys,
  variantMap: navWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, navWrapperVariantKeys)
  },
  getVariantProps: navWrapperFn.getVariantProps,
})